import { useEffect, useState } from "react";

// Small local debounce used by the Payment Ops search inputs so filter state
// in the URL (and therefore the server-side query) settles before firing.
export const useDebouncedValue = <T>(value: T, delayMs = 400): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return debouncedValue;
};
